import { CreaturesConst } from "../const/creaturesConst"

export const getCreatureDetailsHelper = (id: string) => {
    return CreaturesConst.find((creature) => {
        return creature.id === id
    })
}